import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-promotional-calls',
  templateUrl: './promotional-calls.component.html',
  styleUrls: ['./promotional-calls.component.scss']
})
export class PromotionalCallsComponent {
 
  constructor(
    private titleService: Title,
  )
  {    }

  ngOnInit(){
    this.titleService.setTitle('Promotional Calls');
  }


}
